<template>
    <v-layout align-center>
        <p class="page-text primary--text mr-4 mr-lg-10">
            보유 포인트:
        </p>
        <v-chip color="grey-f1">
            <span class="font-weight-bold grey-13--text">
                {{ (user?.point || 0).format() }}원
            </span>
        </v-chip>
    </v-layout>
    <!-- <v-row justify="end" align="center" class="ma-0">
        <v-col cols="auto" class="py-0 font-size-16 txt-primary-color">보유포인트 : </v-col>
        <v-col cols="auto" class="py-0">
            <v-btn small rounded color="" class="black--text font-weight-bold font-size-14 border-radius-fill">{{ (user?.point || 0).format() }}원</v-btn>
        </v-col>
    </v-row> -->
</template>

<script>
import { USER_TYPES } from "@/assets/variables";
export default {
    computed: {
        user() {
            return this.$store.state.user;
        },
        isCompany() {
            return this.user?.type == USER_TYPES.COMPANY.value;
        },
    },
};
</script>

<style>
</style>